import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: 'input[OnlynumberDirective]'
})
export class OnlynumberDirectiveDirective {

  constructor(private _el: ElementRef) { }

  @HostListener('input', ['$event']) keypress(event) {
    const initalValue = this._el.nativeElement.value;

    this._el.nativeElement.value = initalValue.replace(/[^0-9/+-.]*/g, '');
    if (initalValue !== this._el.nativeElement.value || initalValue.maxLength > 2) {
      event.stopPropagation();
    }
  }
}
